import { render, staticRenderFns } from "./DoorGlazing.vue?vue&type=template&id=b558ef94&scoped=true"
import script from "./DoorGlazing.vue?vue&type=script&lang=ts"
export * from "./DoorGlazing.vue?vue&type=script&lang=ts"
import style0 from "./DoorGlazing.vue?vue&type=style&index=0&id=b558ef94&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b558ef94",
  null
  
)

export default component.exports